import { render, staticRenderFns } from "./MenuBranchListIcon.vue?vue&type=template&id=ab46f130&"
import script from "./MenuBranchListIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuBranchListIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports